/* tslint:disable */
/* eslint-disable */
/* @relayHash b7f033e78e670c4898f7159d28fa0833 */

import { ConcreteRequest } from "relay-runtime";
export type getSocialNetworksQueryVariables = {};
export type getSocialNetworksQueryResponse = {
    readonly viewer: {
        readonly socialNetworks: ReadonlyArray<{
            readonly name: string | null;
            readonly parameters: {
                readonly clientId: string | null;
            } | null;
        } | null> | null;
    };
};
export type getSocialNetworksQuery = {
    readonly response: getSocialNetworksQueryResponse;
    readonly variables: getSocialNetworksQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "parameters",
  "storageKey": null,
  "args": null,
  "concreteType": "SocialNetworkParameters",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "clientId",
      "args": null,
      "storageKey": null
    }
  ]
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getSocialNetworksQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "socialNetworks",
            "storageKey": null,
            "args": null,
            "concreteType": "SocialNetwork",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "getSocialNetworksQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "socialNetworks",
            "storageKey": null,
            "args": null,
            "concreteType": "SocialNetwork",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/)
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "getSocialNetworksQuery",
    "id": "ferrum/293.0.0-2020-12-03T17:06:45.415Z/getSocialNetworksQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '9c25b76e788503e4a2417072e940c08c';
export default node;
